import React from 'react';
import Logger from '../../util/Logger';
import './Navbar.css';
import Tooltip from '../shared/Tooltip';

export default class NavbarIcon extends React.Component {

  handleClick = ($event) => {
    const { handleClick } = this.props;
    if (handleClick) {
      $event.preventDefault();

      handleClick();
    }
  };

  constructor (props) {
    super(props);

    if (!props.icon) {
      Logger.assert('NavbarItem requires "icon"');
    }

    if (!props.tooltip) {
      Logger.assert('NavbarItem requires "tooltip" hover text');
    }
  }

  render () {
    const { icon, hideIfSmall, tooltip } = this.props;
    return (
      <div
        onClick={ this.handleClick }
        className={
          `px-1 px-lg-1 px-xl-2 font-size-sm clickable route fix-ie navbar-item
           ${hideIfSmall && 'display-if-large-enough'}` }>
        <div className="route row font-size-sm no-gutters d-flex h-100">
          <Tooltip tooltip={ tooltip } placement="bottom">
            <i className="fix-ie material-icons">{ icon }</i>
          </Tooltip>
        </div>
      </div>
    );
  }

}
